import { AllRows, Columns, ReportData } from '../result.interface';


export function getFileExportResumenPorDia(ctx: any, vrs: number): any {
    
        var exportFileEx = [];
        var bol_datos_ex = false;
        var column_config:Columns[] = [];
    
        var codigo_cell_ch_width = "Codigo".length;
        var placa_cell_ch_width = "Placa".length;

        var fecha_inicial_cell_ch_width = "Fecha Inicial".length;
        var hora_inicio_cell_ch_width = "Hora Inicio".length;
        var fecha_final_cell_ch_width = "Fecha Final".length;
        var hora_fin_cell_ch_width = "Hora Fin".length;
        
        var recorrido_cell_ch_width = "Recorrido".length;

        var duracion_movimiento_cell_ch_width = "Tiempo en Movimiento".length;
        var duracion_relenti_cell_ch_width = "Tiempo Relenti".length;
        var duracion_apagado_cell_ch_width = "Tiempo Apagado".length;
        var duracion_parada_cell_ch_width = "Duración Paradas".length;

        var contador_parada_cell_ch_width = "Contador Paradas".length;
        var velocidad_maxima_cell_ch_width = "Velocidad Maxima".length;
        var velocidad_promedio_cell_ch_width = "Velocidad Promedio".length;

        // var conteo_exceso_cell_ch_width = "Conteo Excesos de Velocidad".length;

        // var consumo_combustible_cell_ch_width = "Consumo Combustiblr".length;
        // var costo_combustible_cell_ch_width = "Costo Combustible".length;
        // var grupo_cell_ch_width = "Grupo".length;
        // var marca_cell_ch_width = "Marca".length;
        // var modelo_cell_ch_width = "Modelo".length;

    
        var table_width = (ctx.chkDateHour? 6: 4) + 13;
        var vehiculo_width = ctx.chkDateHour? 6: 4;
    
        var nom_inf = "REPORTE RESUMEN POR DIA";
    
        var allRows: AllRows[] = [
            {
              cells: [
                { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
              ],
              height: ctx.headerRowsHeight,
            },
            ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
        ];
    
    
    
        ctx.sortedData.forEach((table_data: any) => {
          if(table_data[1].length > 0){
            column_config = [];
            var p_cercano_width = 155;
            var z_cercana_width = 165;
    
            bol_datos_ex = true;
    
            var nom_vehi = table_data[0][1];

            var rows: AllRows[] = [
              {
                cells: [
                  { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
                ],
                height: ctx.headerRowsHeight,
              },
              ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
              {
                cells: [
                  { value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
                  { value: "PERIODO",  ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
                ],
                height: ctx.subHeaderHeight,
              },
              {
                cells: [
                  { value: table_data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width, rowSpan: ctx.subHeaderContentRowSpan },
                  { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width, rowSpan: ctx.subHeaderContentRowSpan },
                ],
                height: ctx.subHeaderContentHeight,
              },
              ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
            ];
    
            /* Table Body */
    
            var cellsCampos = [];
    
            //----------- CABECERA ------------

  
            cellsCampos.push({ value: "Ítem", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Código", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Placa", ...ctx.colHeaderConfig });

            if (ctx.chkDateHour) {
              cellsCampos.push({ value: "Fecha Inicial", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Hora Inicio", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Fecha Final", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Hora Fin", ...ctx.colHeaderConfig });
            } else {
              cellsCampos.push({ value: "Fecha/Hora Inicial", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Fecha/Hora Final", ...ctx.colHeaderConfig });
            }
  
            cellsCampos.push({ value: "Recorrido", ...ctx.colHeaderConfig });

            cellsCampos.push({ value: "Timepo en Movimiento", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Tiempo Relenti", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Tiempo Apagado", ...ctx.colHeaderConfig });  
            cellsCampos.push({ value: "Duración Paradas", ...ctx.colHeaderConfig });

            cellsCampos.push({ value: "Contador Paradas", ...ctx.colHeaderConfig });  
            cellsCampos.push({ value: "Velocidad Máxima", ...ctx.colHeaderConfig });
            cellsCampos.push({ value: "Velocidad Promedio", ...ctx.colHeaderConfig });
            
            
            // cellsCampos.push({ value: "Conteo Excesos De Velocidad", ...ctx.colHeaderConfig });

            // cellsCampos.push({ value: "Consumo Combustible", ...ctx.colHeaderConfig });
            // cellsCampos.push({ value: "Costo Combustible", ...ctx.colHeaderConfig });
            // cellsCampos.push({ value: "Grupo", ...ctx.colHeaderConfig });
            // cellsCampos.push({ value: "Marca", ...ctx.colHeaderConfig });
            // cellsCampos.push({ value: "Modelo", ...ctx.colHeaderConfig });            
    
            rows.push({
              cells: cellsCampos,
              height: ctx.colsHeaderHeight,
            });
    
            //----------- CONTENIDO / FILAS ------------
    
            table_data[1].forEach((item: {  
                    codigo: string; fecha_inicial: any; fecha_final: any; 
                    recorrido: string; duracion_movimiento: string;
                    duracion_ralenti: string; duracion_apagado: string; 
                    duracion_parada: string; 
                    contador_parada: string; velocidad_maxima: string; 
                    velocidad_promedio: string; conteo_excesos_velocidad: string; 
                    consumo_combustible: string; costo_combustible: string; 
                    grupo: string; placa: string; 
                    marca: string; modelo: string; 
                  }, index: number) => {


              var cellsCuerpo = [];

              codigo_cell_ch_width = Math.max(codigo_cell_ch_width, (item.codigo??'').toString().length);
              placa_cell_ch_width = Math.max(placa_cell_ch_width, (item.placa??'').toString().length);
              recorrido_cell_ch_width = Math.max(recorrido_cell_ch_width, (item.recorrido??'').toString().length);
              
              duracion_movimiento_cell_ch_width = Math.max(duracion_movimiento_cell_ch_width, (item.duracion_movimiento??'').toString().length);
              duracion_relenti_cell_ch_width = Math.max(duracion_relenti_cell_ch_width, (item.duracion_ralenti??'').toString().length);
              duracion_apagado_cell_ch_width = Math.max(duracion_apagado_cell_ch_width, (item.duracion_apagado??'').toString().length); 
              duracion_parada_cell_ch_width = Math.max(duracion_parada_cell_ch_width, (item.duracion_parada??'').toString().length);
              
              
              contador_parada_cell_ch_width = Math.max(contador_parada_cell_ch_width, (item.contador_parada??'').toString().length);
              velocidad_maxima_cell_ch_width = Math.max(velocidad_maxima_cell_ch_width, (item.velocidad_maxima??'').toString().length);
              velocidad_promedio_cell_ch_width = Math.max(velocidad_promedio_cell_ch_width, (item.velocidad_promedio??'').toString().length);
              
              // conteo_exceso_cell_ch_width = Math.max(conteo_exceso_cell_ch_width, (item.conteo_excesos_velocidad??'').toString().length);

              // consumo_combustible_cell_ch_width = Math.max(consumo_combustible_cell_ch_width, (item.consumo_combustible??'').toString().length);
              // costo_combustible_cell_ch_width = Math.max(costo_combustible_cell_ch_width, (item.costo_combustible??'').toString().length);
              // grupo_cell_ch_width = Math.max(grupo_cell_ch_width, (item.grupo??'').toString().length);
              // marca_cell_ch_width = Math.max(marca_cell_ch_width, (item.marca??'').toString().length);
              // modelo_cell_ch_width = Math.max(modelo_cell_ch_width, (item.modelo??'').toString().length);

   
              cellsCuerpo.push({ value: index + 1, ...ctx.bodyRowsConfig });
              cellsCuerpo.push({ value: item.codigo, ...ctx.bodyRowsConfig });
              cellsCuerpo.push({ value: item.placa, ...ctx.bodyRowsConfig });

              if (ctx.chkDateHour) {
                cellsCuerpo.push({ value: ctx.isChe(item.fecha_inicial), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: ctx.isChs(item.fecha_inicial), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
              } else {
                cellsCuerpo.push({ value: ctx.isChe(item.fecha_inicial), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
              }

              if (ctx.chkDateHour) {
                cellsCuerpo.push({ value: ctx.isChe(item.fecha_final), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: ctx.isChs(item.fecha_final), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
              } else {
                cellsCuerpo.push({ value: ctx.isChe(item.fecha_final), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
              }

              cellsCuerpo.push({ value: item.recorrido, ...ctx.bodyRowsConfig });

              cellsCuerpo.push({ value: item.duracion_movimiento, ...ctx.bodyRowsConfig });
              cellsCuerpo.push({ value: item.duracion_ralenti, ...ctx.bodyRowsConfig });
              cellsCuerpo.push({ value: item.duracion_apagado, ...ctx.bodyRowsConfig });
              cellsCuerpo.push({ value: item.duracion_parada, ...ctx.bodyRowsConfig });

              cellsCuerpo.push({ value: item.contador_parada, ...ctx.bodyRowsConfig });
              cellsCuerpo.push({ value: item.velocidad_maxima, ...ctx.bodyRowsConfig });
              cellsCuerpo.push({ value: item.velocidad_promedio, ...ctx.bodyRowsConfig });


              // cellsCuerpo.push({ value: item.conteo_excesos_velocidad, ...ctx.bodyRowsConfig });

              // cellsCuerpo.push({ value: item.consumo_combustible, ...ctx.bodyRowsConfig });
              // cellsCuerpo.push({ value: item.costo_combustible, ...ctx.bodyRowsConfig });
              // cellsCuerpo.push({ value: item.grupo, ...ctx.bodyRowsConfig });
              // cellsCuerpo.push({ value: item.marca, ...ctx.bodyRowsConfig });
              // cellsCuerpo.push({ value: item.modelo, ...ctx.bodyRowsConfig });

              rows.push({
                cells:cellsCuerpo,
                height: ctx.bodyRowsHeight,
              });
            });
    
            
            // //********************************************* excel version 2 *********************************
            if ( vrs == 2 ) {
              rows.splice(0, ctx.headerRowSpan);
              rows.push(...ctx.spaceBetweenTables);
              allRows = allRows.concat(rows);
            }
            // //********************************************* excel version 2 *********************************
    
            // //********************************************* excel version 1 *********************************
    
            /* Ancho de Columnas */
    
            if( vrs == 1 ){
              
              column_config = [
                { width: ctx.w_item },
                { width: ctx.calculateColWidth(codigo_cell_ch_width) },
                { width: ctx.calculateColWidth(placa_cell_ch_width) },
              ];
              if(ctx.chkDateHour){
                column_config.push(
                  { width: ctx.w_date },
                  { width: ctx.w_hour },
                  { width: ctx.w_date },
                  { width: ctx.w_hour },
                )
              } else {
                column_config.push(
                  { width: ctx.w_date_and_hour },
                  { width: ctx.w_date_and_hour },
                )
              }
              column_config.push(
                { width: ctx.calculateColWidth(recorrido_cell_ch_width) },

                { width: ctx.calculateColWidth(duracion_movimiento_cell_ch_width) },
                { width: ctx.calculateColWidth(duracion_relenti_cell_ch_width) },
                { width: ctx.calculateColWidth(duracion_apagado_cell_ch_width) },
                { width: ctx.calculateColWidth(duracion_parada_cell_ch_width) },

                { width: ctx.calculateColWidth(contador_parada_cell_ch_width) },

                { width: ctx.calculateColWidth(velocidad_maxima_cell_ch_width) },
                { width: ctx.calculateColWidth(velocidad_promedio_cell_ch_width) },

                // { width: ctx.calculateColWidth(conteo_exceso_cell_ch_width) },

                // { width: ctx.calculateColWidth(consumo_combustible_cell_ch_width) },
                // { width: ctx.calculateColWidth(costo_combustible_cell_ch_width) },
                // { width: ctx.calculateColWidth(grupo_cell_ch_width) },
                // { width: ctx.calculateColWidth(marca_cell_ch_width) },
                // { width: ctx.calculateColWidth(modelo_cell_ch_width) },
              );
  
              /* Fin Ancho de Columnas */
    
              exportFileEx.push({
                freezePane: {
                    rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
                  },
                columns: column_config,
                title: nom_vehi,
                rows: rows
              });
    
              codigo_cell_ch_width = "Codigo".length;
              placa_cell_ch_width = "Placa".length;

              recorrido_cell_ch_width = "Recorrido".length;
              duracion_movimiento_cell_ch_width = "Duración Movimiento".length;
              duracion_relenti_cell_ch_width = "Duración Relenti".length;
              duracion_apagado_cell_ch_width = "Duración Apagado".length;

              duracion_parada_cell_ch_width = "Duración Paradas".length;
              contador_parada_cell_ch_width = "Contador Paradas".length;

              velocidad_maxima_cell_ch_width = "Velocidad Maxima".length;
              velocidad_promedio_cell_ch_width = "Velocidad Promedio".length;
              // conteo_exceso_cell_ch_width = "Conteo Excesos de Velocidad".length;
      
              // consumo_combustible_cell_ch_width = "Consumo Combustiblr".length;
              // costo_combustible_cell_ch_width = "Costo Combustible".length;
              // grupo_cell_ch_width = "Grupo".length;
              // marca_cell_ch_width = "Marca".length;
              // modelo_cell_ch_width = "Modelo".length;
    
            }
            // //********************************************* excel version 1 *********************************
    
    
    
          } // if si hay datos del vehiculo
        });
    
        //NOTA: width * 1.28 (aprox) = Ancho de columna en excel
    
        //********************************************* excel version 2 *********************************
        if (vrs == 2) {
          allRows[0].cells![0].colSpan = table_width;

          column_config = [
            { width: ctx.w_item },
            { width: ctx.calculateColWidth(placa_cell_ch_width) },
            { width: ctx.calculateColWidth(codigo_cell_ch_width) },
          ];
          if(ctx.chkDateHour){
            column_config.push(
              { width: ctx.w_date_ini_fin },
              { width: ctx.w_hour_ini_fin },
              { width: ctx.w_date_ini_fin },
              { width: ctx.w_hour_ini_fin },
            )
          } else {
            column_config.push(
              { width: ctx.w_date_and_hour },
              { width: ctx.w_date_and_hour },
            )
          }
          column_config.push(
            { width: ctx.calculateColWidth(recorrido_cell_ch_width) },

            { width: ctx.calculateColWidth(duracion_movimiento_cell_ch_width) },
            { width: ctx.calculateColWidth(duracion_relenti_cell_ch_width) },
            { width: ctx.calculateColWidth(duracion_apagado_cell_ch_width) }, 
            { width: ctx.calculateColWidth(duracion_parada_cell_ch_width) },

            { width: ctx.calculateColWidth(contador_parada_cell_ch_width) },
            { width: ctx.calculateColWidth(velocidad_maxima_cell_ch_width) },
            { width: ctx.calculateColWidth(velocidad_promedio_cell_ch_width) },

            // { width: ctx.calculateColWidth(conteo_exceso_cell_ch_width) },

            // { width: ctx.calculateColWidth(consumo_combustible_cell_ch_width) },
            // { width: ctx.calculateColWidth(costo_combustible_cell_ch_width) },
            // { width: ctx.calculateColWidth(grupo_cell_ch_width) },
            // { width: ctx.calculateColWidth(marca_cell_ch_width) },
            // { width: ctx.calculateColWidth(modelo_cell_ch_width) },
          );
    
          exportFileEx.push({
            freezePane: {
                rowSplit: ctx.headerRowSpan
              },
            columns: column_config,
            title: "Resultado",//data[0][1],
            rows: allRows
          });
    
        }


        console.log("===>exportFileEx getFileExportResumenPorDia", exportFileEx);  
        
        if (bol_datos_ex) {
            return exportFileEx;
        } else {
            return [];
        }

}


